import TrackerGrid from "@/components/TrackerGrid";

// Phase 21 (item 6) — Daily Print Job Tracker. Access-gated to the Print
// PO (`print.job@mitgurukul.com`) and super admins via the backend
// endpoint; the nav link in Header.jsx is also hidden from non-authorized
// users.
export default function PrintJobTrackerPage() {
  return (
    <TrackerGrid
      title="Print Job Tracker"
      subtitle="Daily tracker of all Print Job requisitions · ref, token, SPOC, status, pages & cost"
      endpoint="/analytics/print-job-tracker"
      exportPath="/analytics/print-job-tracker/export.xlsx"
      exportFilename="print_job_tracker"
      columns={[
        { key: "ref_code",                 label: "Ref Code" },
        { key: "daily_token",              label: "Daily Token" },
        { key: "submitted_at",             label: "Submitted At" },
        { key: "tentative_required_by",    label: "Required By" },
        { key: "tentative_required_by_time", label: "Required-by Time" },
        { key: "spoc_name",                label: "SPOC Name" },
        { key: "spoc_email",               label: "SPOC Email" },
        { key: "spoc_contact",             label: "SPOC Contact" },
        { key: "main_department",          label: "Main Dept" },
        { key: "sub_department",           label: "Sub Dept" },
        { key: "purpose",                  label: "Purpose", wide: true },
        { key: "is_repeat",                label: "Repeat?" },
        { key: "parent_ref",               label: "Parent Ref" },
        { key: "hod_self_skip",            label: "HOD Skip" },
        { key: "hod_actor_email",          label: "HOD Email" },
        { key: "hod_latest_decision",      label: "HOD Decision" },
        { key: "hod_latest_remark",        label: "HOD Remark", wide: true },
        { key: "po_actor_email",           label: "PO Email" },
        { key: "po_latest_status_key",     label: "PO Status Key" },
        { key: "po_latest_status_label",   label: "PO Status", wide: true },
        { key: "po_latest_remark",         label: "PO Remark", wide: true },
        { key: "grand_total",              label: "Grand Total" },
        { key: "row_count",                label: "Rows" },
        { key: "total_copies",             label: "Total Copies" },
        { key: "pages_total",              label: "Pages × Copies" },
        { key: "color_pages_total",        label: "Color p×c" },
        { key: "bw_pages_total",           label: "B&W p×c" },
        { key: "status",                   label: "Status" },
        { key: "current_stage",            label: "Stage" },
        { key: "holiday_notice_sent",      label: "Holiday Notice" },
      ]}
      dateRangeKey="tentative_required_by"
    />
  );
}
